import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SaidaSistema } from '@models/Autenticacao/SaidaSistema.model';
import { View } from 'ol';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UtilService {
  constructor(private httpClient: HttpClient) {
    this._eventoNovaURLTilemapSelecionada = this._eventoNovaURLTilemapSelecionada ?? new EventEmitter<string>();
    this._eventoNovaURLTilemapSelecionada = this._eventoNovaURLTilemapSelecionada ?? new EventEmitter<string>();
    this._eventoPreparoLayerAdequado = this._eventoPreparoLayerAdequado ?? new EventEmitter<number>();
    this._eventoSolicitacaoSelecaoCoordenadas = this._eventoSolicitacaoSelecaoCoordenadas ?? new EventEmitter<string>();
    this._eventoURLPowerBI = this._eventoURLPowerBI ?? new EventEmitter<string>();
  }

  funcaoObterURLAPI = (): string => {
    if (location.port) {
      return location.protocol + '//' + location.hostname + ':' + location.port + '/' + 'api';
    } else {
      return location.protocol + '//' + location.hostname + '/' + 'api';
    }
  }

  funcaoObterProjecaoMapa = (): string => {
    return 'EPSG:4326';
  }

  funcaoObterViewCentroBrasil = (): View => {
    return this.funcaoObterView(-52, -16, 5);
  }

  funcaoObterView = (longitude: number, latitude: number, zoom: number): View => {
    return new View({ projection: this.funcaoObterProjecaoMapa(), center: [longitude, latitude], zoom: zoom, maxZoom: 22, minZoom: 4 })
  }

  funcaoObterStringAnimacaoSelecao = (): string => {
    return 'selecao_';
  }

  funcaoObterStringDesenho = (): string => {
    return 'desenho_';
  }

  funcaoObterStringLocal = (): string => {
    return 'local_';
  }

  funcaoObterStringAnimacaoTimeline = (): string => {
    return 'timeline_';
  }

  funcaoObterCodigoFiltro = (descricaoFiltro: string) => {
    switch (descricaoFiltro) {
      case 'TextoIgual':
        return 11;
      case 'TextoIniciandoCom':
        return 12;
      case 'TextoTerminandoCom':
        return 13;
      case 'TextoContendoTrecho':
        return 14;
      case 'DataEntre':
        return 24;
      case 'DataApos':
        return 22;
      case 'DataAntes':
        return 23;
      case 'NumericoIgual':
        return 31;
      case 'NumericoMaiorQue':
        return 32;
      case 'NUmericoMenorQue':
        return 33;
      case 'NumericoEntre':
        return 34;
    }
  }

  funcaoObterDescricaoTipo(codigo: number): string {
    switch (codigo) {
      case 1: {
        return "Data / Hora";
      }
      case 2: {
        return "Texto";
      }
      case 3: {
        return "Inteiro";
      }
      case 4: {
        return "Decimal";
      }
      case 5: {
        return "Arquivo Base64";
      }
      case 6: {
        return "URL";
      }
      case 7: {
        return "URL Vídeo";
      }
      case 8: {
        return "Texto Fixo";
      }
      case 101: {
        return "(Sistema) Data / Hora";
      }
      case 102: {
        return "(Sistema) Geolocalização";
      }
      case 103: {
        return "(Sistema) Tipo";
      }
      case 104: {
        return "(Sistema) Título";
      }
      default: {
        return "Erro";
      }
    }
  }

  funcaoObterCampo(codigo: number, campo: string): string {
    switch (codigo) {
      case 101: {
        return "sistema_datahora";
      }
      case 102: {
        return "sistema_wkt";
      }
      case 103: {
        return "sistema_tipo";
      }
      case 104: {
        return "sistema_titulo";
      }
      default: {
        return campo;
      }
    }
  }

  funcaoDeterminarSeTipoTextoFixo(codigo: number): boolean {
    switch (codigo) {
      case 8:
        return true;
      default: {
        return false;
      }
    }
  }

  funcaoDeterminarSeTipoTexto(codigo: number): boolean {
    switch (codigo) {
      case 2:
      case 103:
      case 104:
        return true;
      default: {
        return false;
      }
    }
  }

  funcaoDeterminarSeTipoNumerico(codigo: number): boolean {
    switch (codigo) {
      case 3:
      case 4:
        return true;
      default: {
        return false;
      }
    }
  }

  funcaoDeterminarSeTipoVideo(codigo: number): boolean {
    return [7].includes(codigo);
  }

  funcaoDeterminarSeTipoData(codigo: number): boolean {
    switch (codigo) {
      case 1:
      case 101:
        return true;
      default:
        return false;
    }
  }

  funcaoObterNumeroDecimalDeString = (valor: string): number => {
    var decimal = Number(valor?.toString().replace(",", "."))
    return decimal;
  }

  public _eventoURLPowerBI: EventEmitter<string>;
  funcaoInformarNovaURLPowerBI = (url: string) => {
    this._eventoURLPowerBI.emit(url);
  }

  public _eventoNovaURLTilemapSelecionada: EventEmitter<string>;
  funcaoInformarNovaURLTilemapSelecionada = (url: string) => {
    this._eventoNovaURLTilemapSelecionada.emit(url);
  }

  public _eventoPreparoLayerAdequado: EventEmitter<number>;
  funcaoPrepararLayerAdequado = (numeroRegistros: number) => {
    this._eventoPreparoLayerAdequado.emit(numeroRegistros);
  }

  versao = "";
  urlPowerBI = "about:blank";
  cliente = "";
  titulo = "";
  localTitleService: Title;
  funcaoObterVersao = (titleService: Title): string => {
    if (this.versao == "") {
      this.versao = "...";
      this.localTitleService = titleService;
      this.httpClient.get<SaidaSistema>(`${this.funcaoObterURLAPI()}/conta/ObterVersao`).subscribe((data: SaidaSistema) => {
        this.versao = data.versao;
        this.cliente = data.cliente;
        this.titulo = data.titulo;
        this.urlPowerBI = data.urlPowerBI;
        this.funcaoInformarNovaURLPowerBI(this.urlPowerBI);
        this.localTitleService?.setTitle(data.titulo);
      });
    }

    return this.versao;
  }

  funcaoObterModoVersao(): Observable<SaidaSistema> {
    const url = `${this.funcaoObterURLAPI()}/conta/ObterVersao`;
    return this.httpClient.get<SaidaSistema>(url).pipe(
      tap(retorno => retorno),
      map(retorno => retorno),
      catchError(e => {
        return this.errorHandler(e);
      })
    );
  }

  errorHandler(e: any): Observable<any> {
    throw throwError(e);
  }

  funcaoObterVersaoSimplificado = (): string => {
    this.httpClient.get<SaidaSistema>(`${this.funcaoObterURLAPI()}/conta/ObterVersao`).subscribe((data: SaidaSistema) => {
      this.versao = data.versao;
      this.urlPowerBI = data.urlPowerBI;
    });
    return this.versao;
  }

  funcaoObterUrlRecuperacaoSenha(): Observable<string> {
    return this.httpClient.get<SaidaSistema>(`${this.funcaoObterURLAPI()}/conta/ObterUrlRecuperacaoSenha`).pipe(
      map(obj => obj.urlRecuperacaoSenha),
      catchError(e => this.errorHandler(e))
    );
  }

  funcaoObterCliente = (): string => {
    return this.cliente;
  }

  funcaoObterTitulo = (): string => {
    return this.titulo;
  }

  private handleError = (error: any) => {
    let mensagem = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return throwError(mensagem);
  }

  funcaoValorStorageMapaFiltros = (codigoArea: number, nomeUsuario: string): string => {
    return "MapaFiltro_" + nomeUsuario + "_" + codigoArea;
  }

  funcaoValorStorageMapaNumeroRegistros = (nomeUsuario: string): string => {
    return "MapaNumeroRegistros_" + nomeUsuario;
  }

  funcaoValorStorageBuscaFiltros = (nomeUsuario: string): string => {
    return "BuscaFiltro_" + nomeUsuario;
  }

  funcaoValorStorageBuscaCentroZoom = (nomeUsuario: string): string => {
    return "BuscaCentroZoom_" + nomeUsuario;
  }

  funcaoValorStorageMapaCentroZoom = (nomeUsuario: string): string => {
    return "MapaCentroZoom_" + nomeUsuario;
  }

  funcaoValorStorageMapaPoligonos = (nomeUsuario: string): string => {
    return "MapaPoligonos_" + nomeUsuario;
  }

  numeroTotal = 0;
  numeroAtual = 0;
  funcaoInformarTotal = (numeroTotal: number) => {
    this.numeroTotal = numeroTotal;
  }

  funcaoInformarAtual = (numeroAtual: number) => {
    this.numeroAtual = numeroAtual;
  }

  delay = 1000;
  funcaoObterPorcentagemCarregamento = () => {
    var valorPorcentagem = this.numeroAtual / this.numeroTotal * 100;

    if (this.numeroTotal != 0) {
      switch (valorPorcentagem) {
        case 0:
          return "";
        case 100:
          this.delay--;
          if (this.delay <= 0) {
            this.delay = 1000;
            this.numeroAtual = 0;
            this.numeroTotal = 0;
          }
          return "Concluído";
        default:
          if (valorPorcentagem > 100) {
            valorPorcentagem = 100;
          }
          return valorPorcentagem.toFixed(0) + "%";
      }
    }
  }

  funcaoOrdernarPorCampoOrdem(listaObjetos: any[]) {
    return listaObjetos?.sort((n1, n2) => {
      if (n1.ordem > n2.ordem) {
        return 1;
      }
      else if (n1.ordem < n2.ordem) {
        return -1;
      }
      else {
        return 0;
      }
    });
  }

  funcaoTestarPermissao = (modulo: string, listaModulos: string[]) => {
    if (listaModulos?.find(m => m == "Sistema") != null) {
      return true;
    }
    else {
      var listaModulosPermitidos = modulo?.split(",");
      var encontrouModuloPossivel = listaModulos?.find(m1 => listaModulosPermitidos?.find(m2 => m1 == m2)) != null;

      if (encontrouModuloPossivel) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  public _eventoSolicitacaoSelecaoCoordenadas: EventEmitter<string>;
  funcaoSolicitarSelecaoCoordenadasParaInsercaoRegistroIntegracao = (codigoModeloIntegracao: number, tipo: number) => {
    this._eventoSolicitacaoSelecaoCoordenadas.emit(codigoModeloIntegracao + "_" + tipo);
  }
}
